
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/societies/[slug]",
      function () {
        return require("private-next-pages/societies/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/societies/[slug]"])
      });
    }
  